export default "__VITE_ASSET__DqU5_P9d__"